import Breadcrumb from './container';

export default Breadcrumb;
